import {remCalc} from '_themeUtils'

const commonSizes = {
    fontWeight: 300,
}

const buttons = {
    Button: {
        baseStyle: {
            width: '100%',
            minH: remCalc(48),
            gap: 'spacing.2',
            letterSpacing: remCalc(1),
            textTransform: 'uppercase',
            borderRadius: 'none',
            transition: 'all .15s ease-in-out',
            borderColor: 'color.border.button.none',
            textAlign: 'center',
            _disabled: {
                opacity: 1,
                cursor: 'default',
            },
            _hover: {
                textDecoration: 'none',
            },
        },
        sizes: {
            none: {},
            chips: {
                fontSize: remCalc(14),
                fontWeight: 300,
                textTransform: 'none',
                minH: 'auto',
                py: 'spacing.3',
                px: 'spacing.4',
            },
            newsletter: {
                fontSize: remCalc(12),
                fontWeight: 400,
                w: {base: '100%', md: remCalc(176)},
                minW: remCalc(176),
                maxH: 'size.input.height',
            },
            changelocale: {
                fontSize: remCalc(16),
                alignSelf: 'center',
                fontWeight: 300,
                w: {base: '100%', md: remCalc(176)},
                letterSpacing: remCalc(4),
                minW: remCalc(176),
                maxH: 'size.input.height',
            },
            iconButtonSm: {
                minW: remCalc(22),
                maxW: remCalc(22),
                minH: remCalc(22),
                maxH: remCalc(22),
                ...commonSizes,
            },
            iconButtonMd: {
                minW: remCalc(32),
                maxW: remCalc(32),
                minH: remCalc(32),
                maxH: remCalc(32),
                ...commonSizes,
            },
            iconButtonLg: {
                minW: remCalc(36),
                maxW: remCalc(36),
                minH: remCalc(36),
                maxH: remCalc(36),
                ...commonSizes,
            },
            iconButton: {
                minW: remCalc(48),
                maxW: remCalc(48),
                minH: remCalc(48),
                maxH: remCalc(48),
                ...commonSizes,
            },
            xs: {
                textStyle: 'buttonXs',
                lineHeight: 1,
                minH: remCalc(42),
                ...commonSizes,
            },
            sm: {
                textStyle: 'buttonSm',
                lineHeight: 1,
                minH: remCalc(48),
                ...commonSizes,
            },
            md: {
                textStyle: 'buttonMd',
                lineHeight: 1,
                minH: remCalc(54),
                ...commonSizes,
            },
            'textLink-xs': {
                textStyle: 'buttonXs',
                lineHeight: 1,
                w: 'fit-content',
                h: 'fit-content',
                pt: 0,
                pb: 'spacing.1.5',
                ...commonSizes,
            },
            'textLink-sm': {
                textStyle: 'buttonSm',
                w: 'fit-content',
                h: 'fit-content',
                pt: 'spacing.1',
                pb: 'spacing.2',
                ...commonSizes,
            },
            'textLink-md': {
                textStyle: 'buttonMd',
                w: 'fit-content',
                h: 'fit-content',
                py: 'spacing.2',
                ...commonSizes,
            },
            discoverMore: {
                textStyle: 'buttonLinkMd',
                py: 'spacing.2',
                px: 'spacing.1',
                ...commonSizes,
            },
        },
        variants: {
            primary: {
                color: 'color.text.button.primary.default',
                background: 'color.background.button.primary.default',
                _hover: {
                    color: 'color.text.button.primary.hover',
                    background: 'color.background.button.primary.hover',
                    _disabled: {
                        background: 'color.background.button.primary.disabled',
                    },
                },
                _disabled: {
                    color: 'color.text.button.primary.disabled',
                    background: 'color.background.button.primary.disabled',
                },
            },
            outline: {
                color: 'color.text.button.outline.default',
                background: 'color.background.button.outline.default',
                border: '1px solid',
                borderColor: 'color.border.button.outline.default',
                _hover: {
                    background: 'color.background.button.outline.hover',
                    borderColor: 'color.border.button.outline.hover',
                    _disabled: {
                        background: 'color.background.button.outline.disabled',
                        borderColor: 'color.border.button.none',
                    },
                },
                _disabled: {
                    color: 'color.text.button.secondary.disabled',
                    background: 'color.background.button.secondary.disabled',
                    borderColor: 'color.border.button.none',
                },
            },
            outlineLight: {
                color: 'color.text.button.outline.default',
                background: 'color.background.button.outline.default',
                border: '1px solid',
                borderColor: 'color.text.grey.400 !important',
                textTransform: 'none',
                fontWeight: 'normal',
                h: 'auto',
                p: `${remCalc(14)} ${remCalc(10)}`,
                _disabled: {
                    color: 'color.text.button.secondary.disabled',
                    background: 'color.background.button.secondary.disabled',
                    borderColor: 'color.border.button.none',
                },
            },
            secondary: {
                color: 'color.text.button.secondary.default',
                background: 'color.background.button.secondary.default',
                border: '1px solid',
                borderColor: 'color.border.button.secondary',
                _hover: {
                    background: 'color.background.button.secondary.hover',
                    borderColor: 'color.border.button.none',
                    _disabled: {
                        background: 'color.background.button.secondary.disabled',
                        borderColor: 'color.border.button.none',
                    },
                },
                _disabled: {
                    color: 'color.text.button.secondary.disabled',
                    background: 'color.background.button.secondary.disabled',
                    borderColor: 'color.border.button.none',
                },
            },
            newsletter: {
                color: 'color.text.button.newsletter.default',
                background: 'color.background.button.newsletter.default',
                _hover: {
                    color: 'color.text.button.newsletter.hover',
                    background: 'color.background.button.newsletter.hover',
                },
            },
            filter: {
                color: 'color.text.button.filter.default',
                background: 'color.background.button.filter.default',
                fontWeight: 400,
                minH: remCalc(64),
                _hover: {
                    background: 'color.background.button.filter.hover',
                    _disabled: {
                        background: 'color.background.button.filter.disabled',
                    },
                },
                _disabled: {
                    color: 'color.text.button.filter.disabled',
                    background: 'color.background.button.filter.disabled',
                },
            },
            textLink: {
                color: 'color.text.button.textLink.default',
                background: 'color.background.button.none',
                minH: 'auto',
                borderBottom: '1px solid',
                borderColor: 'color.border.button.textLink',

                _hover: {
                    color: 'color.text.button.textLink.hover',
                    background: 'color.background.button.none',
                    _disabled: {
                        color: 'color.text.grey.500',
                    },
                },

                _disabled: {
                    color: 'color.text.grey.500',
                },
            },
            discoverMore: {
                color: 'color.text.button.textLink.default',
                background: 'color.background.button.none',
                w: 'fit-content',
                minH: 'auto',
                borderTop: '1px solid',
                borderBottom: '1px solid',
                borderColor: 'color.border.button.none',
                borderBottomColor: 'color.border.button.textLink',
                _hover: {
                    borderTopColor: 'color.border.button.textLink',
                },
            },
            iconButton: {
                color: 'color.text.button.iconButton.default',
                background: 'color.background.button.iconButton.default',
                _hover: {
                    color: 'color.text.button.iconButton.hover',
                    background: 'color.background.iconButton.hover',
                },
                _disabled: {
                    color: 'color.text.button.iconButton.disabled',
                    background: 'color.background.transparent',
                    _hover: {
                        color: 'color.text.button.iconButton.disabled',
                        background: 'color.background.transparent',
                    },
                },
            },
            iconButtonBgTransparent: {
                color: 'color.text.button.iconButton.default',
                background: 'color.background.transparent',
                _hover: {
                    color: 'color.text.button.iconButton.hover',
                    background: 'color.background.transparent',
                },
                _disabled: {
                    color: 'color.text.button.iconButton.disabled',
                    background: 'color.background.transparent',
                    _hover: {
                        color: 'color.text.button.iconButton.disabled',
                        background: 'color.background.transparent',
                    },
                },
            },
            text: {
                fontSize: remCalc(16),
                alignSelf: 'center',
                fontWeight: 'normal',
                maxH: 'size.input.height',
                textTransform: 'none',
            },
            textUnderline: {
                w: 'auto',
                // fontSize: remCalc(16),
                alignSelf: 'center',
                fontWeight: 'normal',
                maxH: 'size.input.height',
                textTransform: 'none',
                textDecoration: 'underline',
                textUnderlineOffset: remCalc(8),
                _hover: {
                    textDecoration: 'underline',
                    textUnderlineOffset: remCalc(8),
                },
            },
            underline: {
                w: 'auto',
                alignSelf: 'center',
                maxH: 'size.input.height',
                textTransform: 'none',
                borderBottom: '1px solid',
                borderColor: 'color.text.black',
                pb: 'spacing.1.5',
                px: 0,
                _hover: {
                    borderBottom: '1px solid',
                },
            },
            'round-swatch': {
                // Outer box (Figma "Color dots" NUOVA 24px desktop / 26px mobile). The two-ring
                // visual (inner dark dot + grey outer ring when selected) is drawn by the ColorCircle
                // atom via its `selected` prop; the button only adds a grey ring on hover.
                position: 'relative',
                borderRadius: '50%',
                boxSize: {base: remCalc(26), md: remCalc(24)},
                minW: {base: remCalc(26), md: remCalc(24)},
                minH: {base: remCalc(26), md: remCalc(24)},
                maxW: {base: remCalc(26), md: remCalc(24)},
                maxH: {base: remCalc(26), md: remCalc(24)},
                flexShrink: 0,
                p: 0,
                display: 'block',
                textTransform: 'none',
                background: 'transparent',
                border: 'none',
                boxShadow: 'none',
                overflow: 'visible',
                _after: {
                    content: '""',
                    position: 'absolute',
                    inset: '0',
                    borderRadius: '50%',
                    border: '1px solid',
                    borderColor: 'color.border.transparent',
                    transition: 'border-color 0.15s ease',
                    pointerEvents: 'none',
                },
                '&:hover::after': {
                    borderColor: 'color.border.grey.400',
                },
            },
        },
        defaultProps: {
            size: 'md',
            variant: 'primary',
        },
    },
}

export default buttons
